import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { ArrowUpward, ArrowDownward } from '@material-ui/icons';
import { isMobile } from 'react-device-detect';

const styles = theme => ({
  tableHeader: {
    display: 'grid',
    gridTemplateColumns: isMobile ? '120px 120px 120px 120px 100px 100px 100px' : '11% 14% 14% 22% 13% 13% 13%',
    backgroundColor: '#FAFBFC',
    padding: '16px 32px',
    width: isMobile ? '840px' : 'auto',
  },
  headerCell: {
    fontSize: '14px',
    color: '#888B8D',
    fontWeight: 400,
    fontFamily: 'Sura Sans, system-ui',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: '4px'
  },
  arrowIconActive: {
    fontSize: '6px',
    color: '#0033A0',
    lineHeight: '6px'
  },
  arrowIconInactive: {
    fontSize: '6px',
    color: '#888B8D',
    lineHeight: '6px'
  }
});

const TableHeader = ({ 
  classes, 
  sortColumn, 
  sortDirection, 
  onSort 
}) => {

  const getSortIcon = (column) => {
    if (column === 'paid_at') return null;
    if (sortColumn !== column) {
      return (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <ArrowUpward style={{ fontSize: 16, color: '#888B8D' }} />
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <span className={classes.arrowIconInactive}>1</span>
          <span className={classes.arrowIconInactive}>9</span>
          </div>
        </div>
      );
    }
    return sortDirection === 'asc' ? (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <ArrowUpward style={{ fontSize: 16, color: '#0033A0' }} />
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <span className={classes.arrowIconActive}>1</span>
          <span className={classes.arrowIconActive}>9</span>
        </div>
      </div>
    ) : (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <ArrowDownward style={{ fontSize: 16, color: '#0033A0' }} />
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <span className={classes.arrowIconActive}>9</span>
          <span className={classes.arrowIconActive}>1</span>
        </div>
      </div>
    );
  };

  return (
    <div className={classes.tableHeader}>
      <div className={classes.headerCell} onClick={() => onSort('receipt_id')}>
        Recibo {getSortIcon('receipt_id')}
      </div>
      <div className={classes.headerCell} onClick={() => onSort('issue_date')}>
        Vigencia {getSortIcon('issue_date')}
      </div>
      <div className={classes.headerCell} onClick={() => onSort('extension_date')}>
        Fecha límite de pago {getSortIcon('extension_date')}
      </div>
      <div className={classes.headerCell}>
        Fecha de cobro domiciliado
      </div>
      <div className={classes.headerCell} onClick={() => onSort('importMO')}>
        Importe MO {getSortIcon('importMO')}
      </div>
      <div className={classes.headerCell} onClick={() => onSort('currency')}>
        Moneda {getSortIcon('currency')}
      </div>
      <div className={classes.headerCell} onClick={() => onSort('importMXN')}>
        Importe MN {getSortIcon('importMXN')}
      </div>
    </div>
  );
};

export default withStyles(styles)(TableHeader); 


// WEBPACK FOOTER //
// ./src/containers/paymentMovements/components/TableHeader.js